export default __webpack_public_path__ + "static/media/francoischarron.1d05979a.png";